export class AgendamentoSelecionadosStorage {
  private static readonly STORAGE_KEY = 'selecionadosGridAgendamento';
  private static readonly STORAGE_KEY_QTD = 'qtdGridAgendamento';

  static get(codTela: number): any[] {
    try {
      const item = sessionStorage.getItem(`${this.STORAGE_KEY}-${codTela}`);
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error(`Erro ao ler do sessionStorage:`, error);
      return [];
    }
  }

  static set(ids: any[], codTela: number): void {
    try {
      sessionStorage.setItem(
        `${this.STORAGE_KEY}-${codTela}`,
        JSON.stringify(ids),
      );
    } catch (error) {
      console.error(`Erro ao salvar no sessionStorage:`, error);
    }
  }

  static updateConfirmedToTrue(codTela: number): void {
    try {
      const items = this.get(codTela);

      // Verifica se há itens e se são arrays válidos
      if (!Array.isArray(items)) {
        console.warn(
          `Nenhum item encontrado ou o dado não é um array para a tela ${codTela}.`,
        );
        return;
      }

      const updatedItems = items.map((item) => ({
        ...item,
        confirmed: true,
      }));

      this.set(updatedItems, codTela);
    } catch (error) {
      console.error(
        `Erro ao atualizar a chave "confirmed" no sessionStorage:`,
        error,
      );
    }
  }

  static removeById(id: string, codTela: number): void {
    try {
      const items = this.get(codTela);

      if (!Array.isArray(items)) {
        console.warn(
          `Os dados armazenados para a tela ${codTela} não são um array.`,
        );
        return;
      }

      const filteredItems = items.filter((item) => item.id !== id);

      this.set(filteredItems, codTela);
    } catch (error) {
      console.error(
        `Erro ao remover item com id ${id} do sessionStorage:`,
        error,
      );
    }
  }

  static clear(codTela: number): void {
    try {
      sessionStorage.removeItem(`${this.STORAGE_KEY}-${codTela}`);
    } catch (error) {
      console.error(`Erro ao limpar o sessionStorage:`, error);
    }
  }

  static setQtd(qtd: number, codTela: number): void {
    try {
      sessionStorage.setItem(
        `${this.STORAGE_KEY_QTD}-${codTela}`,
        JSON.stringify(qtd),
      );
    } catch (error) {
      console.error(`Erro ao salvar no sessionStorage:`, error);
    }
  }

  static getQtd(codTela: number): number {
    try {
      const item = sessionStorage.getItem(`${this.STORAGE_KEY_QTD}-${codTela}`);
      return item ? JSON.parse(item) : 0;
    } catch (error) {
      console.error(`Erro ao salvar no sessionStorage:`, error);
      return 0;
    }
  }

  static clearAll(codTela: number): void {
    try {
      sessionStorage.removeItem(`${this.STORAGE_KEY}-${codTela}`);
      sessionStorage.removeItem(`${this.STORAGE_KEY_QTD}-${codTela}`);
    } catch (error) {
      console.error(`Erro ao salvar no sessionStorage:`, error);
    }
  }
}
